import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/promo/promo-banner-summer-2025/2560x60x3.jpg")